import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';

import styles from './PointsBadge.module.scss';
import { formatPoints } from '../../utils/formatPoints';

const PointsBadge = ({ pointsData }) => {
  if (!pointsData || pointsData.totalPoints === 0) {
    return null;
  }

  const { contentCardDefault, totalPoints } = pointsData;

  // Определяем иконку и название
  let iconName = 'star'; // Иконка по умолчанию для дополнительных баллов
  let displayName = 'Дополнительные баллы';

  if (contentCardDefault) {
    displayName = contentCardDefault.name || 'Дополнительные баллы';

    // Определяем иконку по типу категории
    if (contentCardDefault.type === 'photo') {
      iconName = 'image';
    } else if (contentCardDefault.type === 'video') {
      iconName = 'video';
    } else if (contentCardDefault.type === 'case') {
      iconName = 'briefcase';
    }
  }

  return (
    <span className={styles.pointsBadge}>
      <span className={styles.leftSection}>
        <Icon name={iconName} className={styles.icon} />
        <span className={styles.name}>{displayName}</span>
      </span>
      <span className={styles.points}>{formatPoints(totalPoints)}</span>
    </span>
  );
};

PointsBadge.propTypes = {
  pointsData: PropTypes.shape({
    contentCardDefault: PropTypes.shape({
      type: PropTypes.string,
      name: PropTypes.string,
      value: PropTypes.number,
    }),
    cardPointAdvancedData: PropTypes.array,
    totalPoints: PropTypes.number,
  }),
};

PointsBadge.defaultProps = {
  pointsData: null,
};

export default PointsBadge;
